import {getCurrentYear} from '../../utils/commons'
import BestExpertsChoiceLogo from './logo'
import {
  bestExpertsChoiceStylesCA,
  bestExpertsChoiceStylesAU,
  bestExpertsChoiceStylesIN,
  bestExpertsChoiceStylesUK,
  bestExpertsChoiceStylesUS,
} from './styles'

const baseConfig = {
  domainName: 'bestexpertschoice' as const,
  domainType: 'picks' as const,
  siteName: 'Best Experts Choice',
  favicon: '/favicons/bestexpertschoice.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-QDPBNSGWD3',
    camelCaseUrl: 'BestExpertsChoice.com',
    logo: <BestExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="us" />,
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the US | There's One Clear Winner | BestExpertsChoice.com`,
    description: (_category?: string, _count?: string) =>
      `BestExpertsChoice.com – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestExpertsChoiceStylesUS,
  },
  uk: {
    measurementId: 'G-ZP63QQQ6K8',
    camelCaseUrl: 'BestExpertsChoice.co.uk',
    logo: <BestExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the UK | There's One Clear Winner | BestExpertsChoice.co.uk`,
    description: (_category?: string, _count?: string) =>
      `BestExpertsChoice.co.uk – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestExpertsChoiceStylesUK,
  },
  ca: {
    measurementId: 'G-BHHKH8TFMG',
    camelCaseUrl: 'BestExpertsChoice.ca',
    logo: <BestExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in CA | There's One Clear Winner | BestExpertsChoice.ca`,
    description: (_category?: string, _count?: string) =>
      `BestExpertsChoice.ca – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestExpertsChoiceStylesCA,
  },
  in: {
    measurementId: 'G-DD5C3M1CNZ',
    camelCaseUrl: 'BestExpertsChoice.in',
    logo: <BestExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="in" />,
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the India | There's One Clear Winner | BestExpertsChoice.in`,
    description: (_category?: string, _count?: string) =>
      `BestExpertsChoice.in – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestExpertsChoiceStylesIN,
  },
  au: {
    measurementId: 'G-PZ89W0DEQJ',
    camelCaseUrl: 'BestExpertsChoice.au',
    domainType: 'eu' as const,
    logo: <BestExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="au" />,
    title: (category: string, count: string) =>
      `Best ${count} ${category} Worth Buying in ${getCurrentYear()} - Aussie Expert Picks | BestExpertsChoice.au`,
    description: (category?: string, _count?: string) =>
      `BestExpertsChoice.au reviews the best ${category} in Australia. Local experts share trusted picks for smarter buying in ${getCurrentYear()}.`,
    styles: bestExpertsChoiceStylesAU,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
